module.exports = __webpack_public_path__ + "static/media/brand-icons.c5ebe0b3.ttf";